import { IDisposable, editor, languages } from 'monaco-editor-core';
import { LUCENE_ID } from './constants';
import { grammar, config } from './lucene';
import { LuceneLanguageService } from './lucene.language.service';

export function setupMode(): IDisposable {
  const disposables: IDisposable[] = [];
  const providers: IDisposable[] = [];

  languages.setLanguageConfiguration(LUCENE_ID, config);

  const languageService = LuceneLanguageService.getInstance();

  editor.onDidCreateModel(model => {
    if (model.getLanguageId() !== LUCENE_ID) {
      return;
    }

    providers.push(
      model.onWillDispose(() => {
        languageService.unregisterModelOptions(model);
      })
    );
  });

  providers.push(languages.registerCompletionItemProvider(LUCENE_ID, languageService));
  providers.push(languages.registerHoverProvider(LUCENE_ID, languageService));
  //   if (modeConfiguration.documentHighlights) {
  //       providers.push(
  //         languages.registerDocumentHighlightProvider(languageId, new languageFeatures.DocumentHighlightAdapter(worker))
  //       );
  //   }
  //   if (modeConfiguration.definitions) {
  //       providers.push(languages.registerDefinitionProvider(languageId, new languageFeatures.DefinitionAdapter(worker)));
  //   }

  //   if (modeConfiguration.references) {
  //       providers.push(languages.registerReferenceProvider(languageId, new languageFeatures.ReferenceAdapter(worker)));
  //   }

  //   if (modeConfiguration.documentSymbols) {
  //       providers.push(
  //         languages.registerDocumentSymbolProvider(languageId, new languageFeatures.DocumentSymbolAdapter(worker))
  //       );
  //   }
  //   if (modeConfiguration.rename) {
  //     providers.push(languages.registerRenameProvider(languageId, new languageFeatures.RenameAdapter(worker)));
  //   }

  //   if (modeConfiguration.colors) {
  //     providers.push(languages.registerColorProvider(languageId, new languageFeatures.DocumentColorAdapter(worker)));
  //   }

  //   if (modeConfiguration.foldingRanges) {
  //     providers.push(
  //       languages.registerFoldingRangeProvider(languageId, new languageFeatures.FoldingRangeAdapter(worker))
  //     );
  //   }

  // if (modeConfiguration.selectionRanges) {
  //   providers.push(
  //     languages.registerSelectionRangeProvider(languageId, new languageFeatures.SelectionRangeAdapter(worker))
  //   );
  // }

  disposables.push(asDisposable(providers));

  return asDisposable(disposables);
}

function asDisposable(disposables: IDisposable[]): IDisposable {
  return { dispose: () => disposeAll(disposables) };
}

function disposeAll(disposables: IDisposable[]) {
  debugger;
  while (disposables.length) {
    disposables.pop()!.dispose();
  }
}

languages.register({
  id: LUCENE_ID,
});

languages.setMonarchTokensProvider(LUCENE_ID, grammar);

languages.onLanguage(LUCENE_ID, () => {
  setupMode();
});
